import { createMutation } from '../api/mutation'
import { keyUser } from './queries'
import { LoginResponse } from './types'

export const useCreateNewAdminUser = createMutation<LoginResponse>({
    url: '/auth/register',
    method: 'POST',
})

export const useLoginUser = createMutation<LoginResponse>({
    url: '/auth/login',
    method: 'POST',
})

export const useForgotPassword = createMutation({
    url: '/auth/forgot-password',
    method: 'POST',
})

export const useResetPassword = createMutation({
    url: '/auth/reset-password',
    method: 'POST',
})

export const useVerifyAdminEmail = createMutation({
    url: '/auth/verify-email',
    method: 'POST',
})

export const useLogout = createMutation({
    url: '/auth/logout',
    method: 'POST',
    keysToRefetch: [keyUser],
    apiOptions: {
        // @ts-ignore
        credentials: 'include',
    },
})

export const useImitateUser = createMutation({
    keysToRefetch: [keyUser],
    url: '/auth/imitate-user',
    method: 'POST',
})

export const useStopImitation = createMutation({
    keysToRefetch: [keyUser],
    url: '/auth/stop-imitation',
    method: 'POST',
})

export const useSetupDemoAccount = createMutation({
    url: '/auth/setup-demo-account',
    method: 'POST',
})

export const useActivateDemoAccount = createMutation({
    url: '/auth/activate-demo-account',
    method: 'POST',
})

export const useAcceptInvitation = createMutation({
    url: '/accept-invite',
    method: 'POST',
})

export const useAcceptInvitationToBusiness = createMutation({
    url: '/accept-business-invitation',
    method: 'POST',
})

export const useAcceptCurrentUserInvitation = createMutation({
    url: '/accept-current-user-invite',
    method: 'POST',
})

export const useResetPasswordInternal = createMutation({
    url: '/auth/reset-password-internal',
    method: 'POST',
})

export const useSwitchAccount = createMutation({
    url: '/auth/switch-account',
    method: 'POST',
})

export const useSwitchBusiness = createMutation({
    url: '/auth/switch-business',
    method: 'POST',
})

export const useSwitchContext = createMutation({
    url: '/auth/switch-context',
    method: 'POST',
})

export const useReorderWorkspaces = createMutation({
    url: '/org-account-order',
    method: 'PATCH',
})

export const useAcceptInviteToBusinessForNewUser = createMutation({
    url: '/accept-business-invitation-new-user',
    method: 'POST',
})

export const useVerifyEmail = createMutation({
    url: '/auth/verify-email',
    method: 'POST',
})

export const useResendVerificationEmail = createMutation({
    url: '/auth/resend-email-verification',
    method: 'POST',
})

export const useMagicLinkLogin = createMutation<{
    userWizardId: string
    redirectUrl: string | null
    userWizardSlug: string | null
    isLoggedIn: boolean
    remaining_uses?: number | null
}>({
    url: '/auth/magic-link/login',
    method: 'POST',
    apiOptions: {
        // @ts-ignore
        credentials: 'include',
    },
})

// Set password for guest who arrived via magic link (freebie flow)
export const useSetPasswordFromMagicLink = createMutation<{ success: boolean; message: string }>({
    url: '/auth/set-password-from-magic-link',
    method: 'POST',
    keysToRefetch: [keyUser],
    apiOptions: {
        // @ts-ignore
        credentials: 'include',
    },
})

// Share magic-link to list of emails / phone numbers
export const useShareMagicLink = createMutation<{ success: boolean }>({
    url: '/auth/magic-link/share',
    method: 'POST',
    apiOptions: {
        // @ts-ignore
        credentials: 'include',
    },
})
